<div class="messages-container">
  @for (msg of messages(); track msg.id) {
    @if (msg.role === 'user') {
      <user-text-bubble [message]="msg" />
    } @else {
      <bot-text-bubble [chatId]="chatId()" [message]="msg" />
    }
  }
</div>
